module.exports = __webpack_public_path__ + "img/box7-img-4.3e1ab79c.png";